import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { AUTH_SOURCE_SECURE_PORTAL, SIGN_IN_VIEW } from 'common/constants/auth';
import { useSignOutAction } from 'pages/Auth/hooks';
import { buildSignInUrl, hasStoredAccessToken } from 'pages/Auth/utils';
import { StyledIconButton } from './PortalAuthButton.styles';
import { PORTAL_AUTH_BUTTON_TEST_IDS } from './PortalAuthButton.testIds';

const PortalAuthButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = hasStoredAccessToken();
  const portalSignInUrl = buildSignInUrl({
    returnTo: `${location.pathname}${location.search}`,
    source: AUTH_SOURCE_SECURE_PORTAL,
    view: SIGN_IN_VIEW.IDENTIFIER,
  });
  const signOut = useSignOutAction({ redirectTo: portalSignInUrl });

  const handleLoginClick = () => {
    navigate(portalSignInUrl);
  };

  return (
    <Box>
      {isLoggedIn ? (
        <StyledIconButton
          aria-label="sign out"
          data-testid={PORTAL_AUTH_BUTTON_TEST_IDS.signOutButton}
          onClick={signOut}
        >
          Sign out
          <AccountCircleOutlinedIcon />
        </StyledIconButton>
      ) : (
        <StyledIconButton
          aria-label="sign in"
          data-testid={PORTAL_AUTH_BUTTON_TEST_IDS.signInButton}
          onClick={handleLoginClick}
        >
          Sign in
          <AccountCircleOutlinedIcon />
        </StyledIconButton>
      )}
    </Box>
  );
};

export default PortalAuthButton;
